import { AttributeGroup } from 'state/attributeGroup'
import { Product } from 'state/product'
import { flatten } from 'state/utils/flatten'

MK.events.on('attribute:group:updateSelections', (event = {}) => {
  const group = event.target

  group.selected = {
    aliases: new Set(),
    attributes: group.attributes.filter(attribute => attribute.is.selected),
    colors: new Set(),
    productIDs: new Set()
  }
  group.is.selected = group.selected.attributes.length > 0

  // Update selections for the current group.
  group.selected.attributes.forEach(attribute => {
    group.selected.aliases = group.selected.aliases.union(attribute.aliases),
    group.selected.colors = group.selected.colors.union(attribute.colors),
    group.selected.productIDs = group.selected.productIDs.union(attribute.productIDs)
  })

  AttributeGroup.active = {
    aliases: new Set(),
    productIDs: new Set(),
    colors: new Set()
  }
  AttributeGroup.selected.groups = AttributeGroup.groups.filter(group => group.is.selected)
  AttributeGroup.selected.attributes = flatten(AttributeGroup.selected.groups.map(group => group.attributes.filter(attribute => attribute.is.selected)))
  AttributeGroup.activeAttributes = []

  if (AttributeGroup.selected.groups.length === 0) {
    MK.events.emit('attribute:groups:clearAllSelections')
    // group.toggle('highlighted', true)
    return
  }

  // Iterate over each attribute group to validate current selections against the group.
  AttributeGroup.groups.forEach(group => {
    // Create array of selected groups, excluding the current group we're evaluating.
    let otherGroupSelections = AttributeGroup.selected.groups.filter(selectedGroup => selectedGroup.id !== group.id)

    group.attributes.forEach(attribute => {
      let active = {
        aliases: new Set(),
        productIDs: new Set(),
        colors: new Set()
      }
      active.aliases = active.aliases.union(attribute.aliases)
      active.colors = active.colors.union(attribute.colors)
      active.productIDs = active.productIDs.union(attribute.productIDs)

      otherGroupSelections.forEach(differentGroup => {
        active.aliases = active.aliases.intersection(differentGroup.selected.aliases)
        active.colors = active.colors.intersection(differentGroup.selected.colors)
        active.productIDs = active.productIDs.intersection(differentGroup.selected.productIDs)
      })

      attribute.is.active = attribute.is.selected || (group.is.selected && active.productIDs.size > 0 && active.aliases.size > 0) || (active.productIDs.size > 0 && active.aliases.size > 0)
      if (attribute.is.selected && active.productIDs.size > 0 && active.aliases.size > 0) {
        AttributeGroup.active.aliases = AttributeGroup.active.aliases.union(active.aliases)
        AttributeGroup.active.colors = AttributeGroup.active.colors.union(active.colors)
        AttributeGroup.active.productIDs = AttributeGroup.active.productIDs.union(active.productIDs)
      }

      if (attribute.is.active) {
        attribute.updateCount(active)
        // attribute.syncWithDOM()
      }
    })

    group.is.active = group.attributes.find(attribute => attribute.is.selected || attribute.is.active)
  })

  console.log(`######################################################################## ${group.name} / Single Attribute Group / Active Selections ########################################################################`)
  console.log(` -> Selected Attributes (${group.selected.attributes.length}): ${group.selected.attributes.map(attribute => attribute.name).join(', ')}`)
  console.log(` -> Aliases (${group.selected.aliases.size}): ${[ ...group.selected.aliases ].join(', ')}`)
  console.log(` -> Colors (${group.selected.colors.size}): ${[ ...group.selected.colors ].join(', ')}`)
  console.log(` -> Product IDs (${group.selected.productIDs.size}): ${[ ...group.selected.productIDs ].join(', ')}`)

  console.log('######################################################################## Active Product Set Across All Attribute Groups ########################################################################')
  console.log(` -> Selected Groups (${AttributeGroup.selected.groups.length}): ${AttributeGroup.selected.groups.map(group => group.name).join(', ')}`)
  console.log(` -> Selected Attributes (${AttributeGroup.selected.attributes.length}): ${AttributeGroup.selected.attributes.map(attribute => attribute.nameLeftNav).join(', ')}`)
  console.log(` -> Aliases (${AttributeGroup.active.aliases.size}): ${[ ...AttributeGroup.active.aliases ].join(', ')}`)
  console.log(` -> Colors (${AttributeGroup.active.colors.size}): ${[ ...AttributeGroup.active.colors ].join(', ')}`)
  console.log(` -> Product IDs (${AttributeGroup.active.productIDs.size}): ${[ ...AttributeGroup.active.productIDs ].join(', ')}`)
  // console.log(`DEBUG (MK.attributeGroup.updateSelections) Active product set calculation took  ${(performance.now() - start)} milliseconds.`)

  if (AttributeGroup.active.aliases.size === 0 || AttributeGroup.active.productIDs.size === 0) {
    MK.events.emit('attribute:groups:clearAllSelections')
    return
  }

  MK.events.emit('products:refine', {
    target: AttributeGroup.active,
    initiator: 'attribute:group:updateSelections'
  })
  // MK.events.emit('attribute:groups:updateDOM', {
  //   initiator: 'attribute:group:updateSelections'
  // })
})
